<template>
  <div>
    <div v-if="isEmbedded" style="height:100vh">
      <Media ref="webrtc" v-if="!fatalError" :key="reloadMedia" />
      <transition name="slide-fade">
        <div class="media-header" v-if="showTitle && !isFullscreen">
          <h1 class="title">
            {{ title }}
          </h1>
          <h1 class="subtitle">
            {{ subtitle }}
          </h1>
        </div>
      </transition>
      <OSD />

      <FatalError class="centered" />
      <div style="position: absolute;right:0;bottom:8rem">
        <div id="notify" class="button is-success is-large close"></div>
      </div>
    </div>
    <div v-else>
      <Navbar />
      <section class="section">
        <div class="container">
          <h1 class="title">
            {{ title }}
          </h1>
          <h1 class="subtitle">
            {{ subtitle }}
          </h1>
          <br />
        </div>
        <div class="container">
          <div class="columns">
            <div class="column is-two-thirds">
              <div id="media" class="media-container">
                <div class="dummy"></div>

                <Media ref="webrtc" v-if="!fatalError" :key="reloadMedia" />
                <OSD />
                <FatalError class="centered modal-card-body" />
                <div style="position: absolute;right:0;bottom:8rem">
                  <div
                    id="notify"
                    class="button is-success is-large close"
                  ></div>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <Stats class="datamate" />
              <!-- <br />
              <div
                class="datamate push-register"
                v-if="store.state.buyerCodes.length < 1"
              >
                Become a registered buyer
              </div> -->
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <LotTable />
        </div>
      </section>
      <!-- <section class="section">
        <div class="container">
          <h2 class="subtitle">Sponsored</h2>
        </div>
      </section> -->
      <Footer />
    </div>
  </div>
</template>

<style lang="scss">
// Import Bulma's core
@import '~bulma/sass/utilities/_all';

// Import customizations
@import 'common/assets/bulma.scss';

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

// User styles
@import 'common/assets/fonts.scss';
@import 'common/assets/custom.scss';

.centered {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: fit-content;
}

.media-container {
  border-radius: 8px;
  background-color: #262a35;
  overflow: hidden;
  position: relative;
  display: flex;
  // min-height: calc((100vmin - 20px) * 0.5625);
}

.media-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  padding: 1.5rem;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.dummy {
  margin-top: 56.25%;
  /* 16:9 aspect ratio */
}

.notices .notification {
  max-width: none;
}

#notify {
  margin-left: auto;
  margin-right: 1.5rem;
  margin-top: 1.5rem;
  transition-duration: 350ms;
  overflow: hidden;
}

#notify.close {
  opacity: 0;
  transform: translateX(100%);
}

.notify {
  position: absolute;
  top: auto;
  right: 0;
  bottom: 25%;
  left: 0;
  z-index: 9;
  padding-right: 0.75rem;
}

.dialog .modal-card {
  max-width: none;
}

.modal-card-head,
.modal-card-foot {
  background-color: #161a25;
}

.modal-card-head {
  border-bottom: 1px solid #333;
}

.modal-card-foot {
  border-top: 1px solid #333;
}

.modal-card-body {
  background-color: #262a35;
}

.datamate {
  background-color: #262a35;
  border-color: #575a62;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  padding: 2rem;
}

.push-register {
  background-color: #3e4557;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-1rem);
  opacity: 0;
}
</style>

<script>
import log from 'loglevel'
import { store } from './socket'
import { bus } from './common/bus'
import { store as newStore } from './common/store'
import { ConfigProgrammatic } from 'buefy'
import JwtDecode from 'jwt-decode'
import auth0 from 'auth0-js'
import VueMobileDetection from 'vue-mobile-detection'
import Meta from 'vue-meta'

import Vue from 'vue'
Vue.use(Meta)
Vue.use(VueMobileDetection)

const CLIENT_ID = 'Gn2DRs0vmYaogz0u23ojOVR7FMTk6dlt'
const APP_DOMAIN = 'prostock.au.auth0.com'
const APP_TENANT = 'prostock'
const APP_ORIGIN = 'livestream'

export default {
  metaInfo() {
    return {
      title: this.subtitle,
      titleTemplate: '%s | Bidding mate',
      // Define meta tags here.
      meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        {
          name: 'description',
          content: this.title + ' | ' + this.subtitle
        }
      ]
    }
  },
  data() {
    return {
      title: '...',
      subtitle: '...',
      store: store,
      newStore: newStore,
      webAuth: null,
      ackTimeout: null,
      notifyTimeout: null,
      fatalError: false,
      reloadMedia: 1,
      showTitle: false,
      showTitleTimeout: false,
      lastLot: 0
    }
  },
  computed: {
    isFullscreen() {
      return store.state.isFullscreen
    },
    isEmbedded() {
      let urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('embedded')) {
        return true
      }
      return this.$isMobile()
    }
  },
  components: {
    Navbar: () => import('@/common/components/Navbar.vue'),
    Footer: () => import('@/common/components/Footer.vue'),
    FatalError: () => import('@/components/FatalError.vue'),
    Media: () => import('@/components/Media.vue'),
    OSD: () => import('@/components/OSD.vue'),
    Stats: () => import('@/components/Stats.vue'),
    LotTable: () => import('@/components/LotTable.vue')
  },
  mounted() {
    log.info('App mounted')

    var mountCtx = this

    // Optional title overlay
    document.addEventListener('mousemove', mountCtx.onMouseMove)

    // Auth0 login
    mountCtx.webAuth = new auth0.WebAuth({
      domain: APP_DOMAIN,
      clientID: CLIENT_ID,
      responseType: 'token id_token',
      scope: 'openid email',
      redirectUri: window.location.href,
      audience: 'https://proapps.prostock.com.au'
    })

    // Look for a JWT
    let urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('id_token')) {
      sessionStorage.setItem('id_token', urlParams.get('id_token'))
      sessionStorage.setItem('expires_at', new Date().getTime())

      try {
        let token = JwtDecode(urlParams.get('id_token'))
        let buyerCodes = token['http://livesale/byr_codes']
        if (buyerCodes !== undefined && buyerCodes.length > 0) {
          store.state.buyerCodes = buyerCodes
          store.state.selectedBuyer = buyerCodes[0]
        }
      } catch (err) {
        log.warn(err)
      }
    } else {
      mountCtx.webAuth.parseHash(function(err, authResult) {
        if (authResult && authResult.idToken) {
          // Just got the login details, extract token and setup session
          window.location.hash = ''

          sessionStorage.setItem('id_token', authResult.idToken)
          sessionStorage.setItem(
            'expires_at',
            authResult.expiresIn * 1000 + new Date().getTime()
          )
          log.info('Set session details')
          try {
            let token = JwtDecode(authResult.idToken)
            let buyerCodes = token['http://livesale/byr_codes']
            log.info(buyerCodes)
            if (buyerCodes !== undefined && buyerCodes.length > 0) {
              store.state.buyerCodes = buyerCodes
              store.state.selectedBuyer = buyerCodes[0]
            }
          } catch (err) {
            log.warn(err)
          }

          window.location.reload(true)
        } else if (err) {
          // Login is invalid
          sessionStorage.removeItem('id_token')
          sessionStorage.removeItem('expires_at')
          mountCtx.webAuth.authorize({
            app_tenant: APP_TENANT,
            origin_app: APP_ORIGIN
          })
        } else if (!mountCtx.isAuthenticated()) {
          log.warn(
            'Token has expired or is not present, send user to login screen'
          )
          mountCtx.webAuth.authorize({
            app_tenant: APP_TENANT,
            origin_app: APP_ORIGIN
          })
        } else {
          mountCtx.newStore.authn = true
        }
      })
    }

    setTimeout(function() {
      try {
        let token = JwtDecode(sessionStorage.getItem('id_token'))
        let buyerCodes = token['http://livesale/byr_codes']
        if (buyerCodes !== undefined && buyerCodes.length > 0) {
          log.info('Using legacy buyer codes: ' + buyerCodes)

          store.state.buyerCodes = buyerCodes
          store.state.selectedBuyer = buyerCodes[0]
        }
      } catch (err) {
        log.warn(err)
      }
    }, 1000)

    // Get tenant configuration
    let headers = new Headers()
    let token = sessionStorage.getItem('access_token')
    if (token != null && token.length > 0) {
      headers.append(
        'Authorization',
        'Bearer ' + sessionStorage.getItem('access_token')
      )
    }
    headers.append('content-type', 'application/json')
    fetch('/config', {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: headers
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          log.error(
            'Server returned ' + response.status + ' : ' + response.statusText
          )
        }
      })
      .then(response => {
        log.info(response)
        this.title = response.market.saleDescription
        this.subtitle = response.site.location
      })
      .catch(err => {
        log.error(err)
      })

    // Setup bus listeners
    bus.$on('bid', function() {
      let payload = {
        action: 'bid',
        buyer: store.state.selectedBuyer,
        token: sessionStorage.getItem('id_token')
      }
      store.send(payload)

      // Setup ack timeout
      mountCtx.ackTimeout = setTimeout(function() {
        mountCtx.fail('No acknowledgement received')
        bus.$emit('lotAdvance')
      }, 2500)
    })
    bus.$on('bidStart', function(startOfLotAmount) {
      let payload = {
        action: 'bidStart',
        buyer: store.state.selectedBuyer,
        token: sessionStorage.getItem('id_token'),
        amount: startOfLotAmount
      }
      store.send(payload)

      // Setup ack timeout
      mountCtx.ackTimeout = setTimeout(function() {
        mountCtx.fail('No acknowledgement received')
        bus.$emit('lotAdvance')
      }, 2500)
    })
    bus.$on('hold', function() {
      let payload = {
        action: 'hold',
        buyer: store.state.selectedBuyer,
        token: sessionStorage.getItem('id_token')
      }
      store.send(payload)

      // Setup ack timeout
      mountCtx.ackTimeout = setTimeout(function() {
        mountCtx.fail('No acknowledgement received')
        bus.$emit('lotAdvance')
      }, 2500)
    })
    bus.$on('cancel', function() {
      let payload = {
        action: 'cancel',
        buyer: store.state.selectedBuyer,
        token: sessionStorage.getItem('id_token')
      }
      store.send(payload)

      // Setup ack timeout
      mountCtx.ackTimeout = setTimeout(function() {
        mountCtx.fail('Round trip failure: no acknowledgement received')
        bus.$emit('lotAdvance')
      }, 2500)
    })
    bus.$on('warning', mountCtx.warn)
    bus.$on('failure', mountCtx.fail)
    bus.$on('switchCodec', function() {
      log.debug('switchCodecApp')
      store.state.useVP8 = !store.state.useVP8
      localStorage.setItem('useVP8', store.state.useVP8)
      mountCtx.reloadMedia++
    })
    // bus.$on('logout', function() {
    //   // Remove tokens and expiry time from sessionStorage
    //   sessionStorage.removeItem('id_token')
    //   sessionStorage.removeItem('expires_at')

    //   window.location.replace(
    //     `https://${APP_DOMAIN}/v2/logout?returnTo=` +
    //       encodeURIComponent(`${window.location.href}`) +
    //       `&client_id=${CLIENT_ID}&app_tenant=${APP_TENANT}&origin_app=${APP_ORIGIN}`
    //   )
    // })
    bus.$on('logout', function() {
      log.error('Deprecated logout event')
    })
    bus.$on('auth', function() {
      if (mountCtx.isAuthenticated()) {
        // Remove tokens and expiry time from sessionStorage
        sessionStorage.removeItem('id_token')
        sessionStorage.removeItem('expires_at')

        mountCtx.webAuth.logout({
          returnTo: window.location.origin,
          clientID: CLIENT_ID,
          state: window.location.href
        })
      } else {
        mountCtx.webAuth.authorize({
          app_tenant: APP_TENANT,
          origin_app: APP_ORIGIN,
          state: window.location.href
        })
      }
    })

    // Connect to signaling server
    store.connect()

    // Setup subscriptions
    store.subscribe('codes', function(payload) {
      try {
        let buyerCodes = payload.codes
        if (buyerCodes !== undefined && buyerCodes.length > 0) {
          log.info('Buyer codes applied: ' + buyerCodes)

          store.state.buyerCodes = buyerCodes
          store.state.selectedBuyer = buyerCodes[0]
        }
      } catch (err) {
        log.warn(err)
      }
    })
    store.subscribe('ack', function() {
      clearTimeout(mountCtx.ackTimeout)
      bus.$emit('ack')
    })
    store.subscribe('won', function() {
      bus.$emit('ack')
      bus.$emit('lotAdvance')
      mountCtx.notify('Lot won', 'is-success')
    })
    store.subscribe('lost', function() {
      bus.$emit('ack')
      bus.$emit('lotAdvance')
      mountCtx.notify('Lot lost', 'is-warning')
    })
    store.subscribe('accepted', function() {
      mountCtx.notify('With you', 'is-info')
    })
    store.subscribe('outbid', function() {
      mountCtx.notify('Against you', 'is-dark')
      bus.$emit('outbid')
    })
    store.subscribe('update', function(payload) {
      bus.$emit('lotUpdate', payload)
      if (payload.lot > mountCtx.lastLot) {
        bus.$emit('lotAdvance')
        mountCtx.lastLot = payload.lot
      }
    })
    store.subscribe('previous', function(payload) {
      bus.$emit('lotPrevious', payload)
    })
  },
  destroyed() {
    clearInterval(this.interval)
    clearInterval(this.ackTimeout)
    bus.$off('bid')
    bus.$off('hold')
    store.disconnect()

    log.info('App destroyed')
  },

  methods: {
    notify(msg, type) {
      let timeout = 5
      let el = document.getElementById('notify')

      el.innerHTML = `<span class="icon"><i class="zmdi zmdi-cloud-outline-alt"></i></span><p>${msg}</p>`

      el.classList.remove(
        'close',
        'is-primary',
        'is-link',
        'is-info',
        'is-success',
        'is-warning',
        'is-danger'
      )
      el.classList.add(type)
      clearTimeout(this.notifyTimeout)
      this.notifyTimeout = setTimeout(() => {
        el.classList.add('close')
      }, timeout * 1000)
    },
    warn(msg) {
      this.$buefy.notification.open({
        indefinite: true,
        closable: false,
        message: '<strong>' + msg + '</strong>',
        position: 'is-top-right',
        type: 'is-warning',
        hasIcon: false,
        queue: false,
        container: (function() {
          if (store.state.isFullscreen) {
            return '#media'
          } else {
            return null
          }
        })()
      })
    },
    fail(msg) {
      bus.$emit('fatal', msg)
      this.fatalError = true
      // this.fatalError += msg + '\n'
      log.error(msg)
    },
    isAuthenticated() {
      // Check whether the current time is past the
      // Access Token's expiry time
      var expiresAt = JSON.parse(sessionStorage.getItem('expires_at'))
      return new Date().getTime() < expiresAt
    },
    onMouseMove() {
      let ctx = this
      ctx.showTitle = true
      clearTimeout(ctx.showTitleTimeout)
      ctx.showTitleTimeout = setTimeout(function() {
        ctx.showTitle = false
      }, 3000)
    }
  }
}

ConfigProgrammatic.setOptions({
  defaultIconPack: 'zmdi',
  customIconPacks: {
    zmdi: {
      sizes: {
        default: 'is-size-5',
        'is-small': '',
        'is-medium': 'is-size-3',
        'is-large': 'is-size-1'
      },
      iconPrefix: 'zmdi-',
      internalIcons: {
        check: 'checkmark',
        information: 'information',
        'check-circle': 'checkmark-circle-outline',
        alert: 'alert-triangle',
        'alert-circle': 'alert-circle-o',
        'arrow-up': 'arrow-up',
        'chevron-right': 'arrow-forward',
        'chevron-left': 'arrow-back',
        'chevron-down': 'arrow-down',
        eye: 'eye',
        'eye-off': 'eye-off',
        'menu-down': 'arrow-dropdown',
        'menu-up': 'arrow-dropup'
      }
    }
  }
})
</script>
